module.exports = __webpack_public_path__ + "media/bangkok/bangkok_small-c72fb836.jpg";